<div>
  <div class="container">
    <div align="center">
      <br>
      <a [href]="environment.baseSiteUrl + '/index.html'"><img class="img-fluid" alt="REDENORTE" [src]="'assets/images/rede_norte_logo.png'"/></a>
    </div>
  </div>
  <div style="border-top: 1px solid #a08e8e; border-bottom: 1px solid #a08e8e" class="mt-3">
    <div class="header-logo-bar">
      <img [src]="'assets/images/rede_norte_header.png'" usemap="#logomap"
           alt="Logos Rede Norte">
    </div>
    <map name="logomap">
      <area target="_blank" alt="IPB" title="IPB" href="http://www.ipb.pt" coords="34,24,179,74" shape="rect">
      <area target="_blank" alt="IPCA" title="IPCA" href="https://ipca.pt/" coords="232,24,347,77" shape="rect">
      <area target="_blank" alt="P.PORTO" title="P.PORTO" href="https://www.ipp.pt/" coords="403,23,600,76,669,14,951,97,870,60" shape="rect">
      <area target="_blank" alt="UTAD" title="UTAD" href="http://www.utad.pt/" coords="921,78,657,20" shape="rect">
      <area target="_blank" alt="IPVC" title="IPVC" href="http://www.ipvc.pt/" coords="971,19,1116,78" shape="rect">
    </map>
  </div>
</div>
<div class="container mt-3 mb-3">
  <div *ngIf="!!user" style="flex: 1; display: flex; flex-direction: column">
    <ul ngbNav class="nav-pills">
      <ng-container *ngFor="let link of links">
        <li ngbNavItem class="mr-2" *ngIf="link.conditional()">
          <a ngbNavLink [routerLink]="link.link" routerLinkActive="active">{{ link.title }}</a>
        </li>
      </ng-container>
      <li style="flex: 1"></li>
      <li ngbNavItem ngbDropdown class="mr-2" routerLinkActive="active" *ngIf="mgmtLinks.length > 0">
        <a ngbNavLink ngbDropdownToggle role="button">
          Gestão
        </a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
          <a ngbDropdownItem [routerLink]="link.link" *ngFor="let link of mgmtLinks" routerLinkActive="active">{{ link.title }}</a>
        </div>
      </li>
      <li ngbNavItem *ngIf="!user.runas">
        <a ngbNavLink href="javascript: void(0)" (click)="logout()"><i class="fa fa-sign-out"></i> Terminar Sessão</a>
      </li>
      <li ngbNavItem *ngIf="user.runas">
        <a ngbNavLink href="javascript: void(0)" (click)="logoutRunas()"><i class="fa fa-undo"></i> Sessão Anterior</a>
      </li>
    </ul>
  </div>
  <div class="m-3">
    <router-outlet></router-outlet>
  </div>
</div>
<div class="app-footer">
  <p>© 2024 | v{{APP_VERSION}} | APNOR . Associação de Politécnicos do Norte</p>
</div>
